/* Bocalia — comportamiento de la landing */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents, format) {
    var value = (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (!format) return '$' + value;
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.bc-reveal:not(.bc-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('bc-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('bc-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCount(root) {
    (root || document).querySelectorAll('[data-bc-count]').forEach(function (el) {
      if (el.dataset.bcDone) return;
      el.dataset.bcDone = '1';
      var target = parseFloat(el.getAttribute('data-bc-count')) || 0;
      var dec = (el.getAttribute('data-bc-count').split('.')[1] || '').length;
      var suffix = el.getAttribute('data-bc-suffix') || '';
      var prefix = el.getAttribute('data-bc-prefix') || '';
      function render(v) { el.textContent = prefix + v.toFixed(dec).replace('.', ',') + suffix; }
      if (reduce || !('IntersectionObserver' in window)) { render(target); return; }
      var started = false;
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting || started) return;
        started = true;
        io.disconnect();
        var start = null;
        function step(t) {
          if (!start) start = t;
          var p = Math.min((t - start) / 1400, 1);
          render(target * (1 - Math.pow(1 - p, 3)));
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }, { threshold: 0.1 });
      io.observe(el);
    });
  }

  function initGallery(root) {
    (root || document).querySelectorAll('[data-bc-gallery]').forEach(function (g) {
      if (g.dataset.bcReady) return;
      g.dataset.bcReady = '1';
      var main = g.querySelector('[data-bc-main]');
      g.querySelectorAll('[data-bc-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!main) return;
          main.style.opacity = '0';
          setTimeout(function () {
            main.src = btn.getAttribute('data-src');
            main.srcset = btn.getAttribute('data-srcset') || '';
            main.alt = btn.getAttribute('data-alt') || '';
            main.style.opacity = '1';
          }, 160);
          g.querySelectorAll('[data-bc-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
          btn.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  function initBuy(root) {
    (root || document).querySelectorAll('[data-bc-buy]').forEach(function (box) {
      if (box.dataset.bcReady) return;
      box.dataset.bcReady = '1';
      var idInput = box.querySelector('input[name="id"]');
      var btn = box.querySelector('[data-bc-submit]');
      var btnPrice = box.querySelector('[data-bc-btn-price]');
      var format = box.getAttribute('data-money-format');
      var sticky = document.querySelector('[data-bc-sticky="' + box.getAttribute('data-section') + '"]');
      var stickyPrice = sticky && sticky.querySelector('[data-bc-sticky-price]');
      var stickyName = sticky && sticky.querySelector('[data-bc-sticky-name]');

      var grid = box.closest('.bc-buy__grid');
      var mainImg = grid && grid.querySelector('[data-bc-main]');

      function apply(radio, swap) {
        if (!radio || !idInput) return;
        if (swap && mainImg && radio.getAttribute('data-img')) {
          mainImg.src = radio.getAttribute('data-img');
          mainImg.srcset = radio.getAttribute('data-srcset') || '';
          mainImg.alt = radio.getAttribute('data-alt') || mainImg.alt;
        }
        idInput.value = radio.value;
        var available = radio.getAttribute('data-available') === 'true';
        var price = parseInt(radio.getAttribute('data-price'), 10);
        if (btn) {
          btn.disabled = !available;
          var label = btn.querySelector('[data-bc-btn-label]');
          if (label) label.textContent = available ? btn.getAttribute('data-label') : btn.getAttribute('data-soldout');
        }
        if (btnPrice) btnPrice.textContent = money(price, format);
        if (stickyPrice) stickyPrice.textContent = money(price, format);
        if (stickyName) stickyName.textContent = radio.getAttribute('data-name');
        try {
          var url = new URL(window.location.href);
          if (url.pathname.indexOf('/products/') !== -1) {
            url.searchParams.set('variant', radio.value);
            window.history.replaceState({}, '', url.toString());
          }
        } catch (e) {}
      }

      box.querySelectorAll('input[data-bc-pack]').forEach(function (r) {
        r.addEventListener('change', function () { apply(r, false); });
      });
      box.querySelectorAll('input[data-bc-pet]').forEach(function (pr) {
        pr.addEventListener('change', function () {
          var cur = box.querySelector('[data-bc-pet-group]:not([hidden]) input[data-bc-pack]:checked');
          var idx = cur ? cur.getAttribute('data-pack-index') : '1';
          var target = null;
          box.querySelectorAll('[data-bc-pet-group]').forEach(function (g) {
            var on = g.getAttribute('data-bc-pet-group') === pr.value;
            g.hidden = !on;
            if (on) target = g.querySelector('input[data-pack-index="' + idx + '"]') || g.querySelector('input[data-bc-pack]');
          });
          if (target) { target.checked = true; apply(target, true); }
        });
      });
      var groups = box.querySelectorAll('[data-bc-pet-group]');
      var first = groups.length ? box.querySelector('[data-bc-pet-group]:not([hidden]) input[data-bc-pack]:checked') : box.querySelector('input[data-bc-pack]:checked');
      apply(first || box.querySelector('input[data-bc-pack]'), false);

      if (sticky && 'IntersectionObserver' in window && btn) {
        var shown = false;
        var io = new IntersectionObserver(function (entries) {
          var e = entries[0];
          var past = !e.isIntersecting && e.boundingClientRect.top < 0;
          if (past !== shown) { shown = past; sticky.classList.toggle('is-on', past); }
        });
        io.observe(btn);
      }
    });
  }

  function initScrollLinks() {
    document.addEventListener('click', function (ev) {
      var a = ev.target.closest && ev.target.closest('a[href^="#bc-"]');
      if (!a) return;
      var target = document.querySelector(a.getAttribute('href'));
      if (!target) return;
      ev.preventDefault();
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  }

  function initAll(root) {
    initReveal(root);
    initCount(root);
    initGallery(root);
    initBuy(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); initScrollLinks(); });
  } else {
    initAll();
    initScrollLinks();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
